import { useGlobalKeyHandler } from '../../../common/hooks/keyboard/useGlobalKeyHandler';

/** @param callback to run when the user presses Enter */
export const useEnterKeyHandler = (callback?: () => void) => useGlobalKeyHandler('Enter', callback);
